<template>
<div class="block">
  <el-carousel class="carousel-xs" v-show="lang == 'zh'" indicator-position="inside" :height="isPc?'540px':calcHeight" >
    <el-carousel-item v-for="(item,index) in tablelist" :key="index">
      <div class="img-div" :style="[{background: 'url('+item.picUrl+') no-repeat'},{backgroundSize:'cover'},{backgroundPosition:'center'}]">

      </div>
    </el-carousel-item>
  </el-carousel>

  <el-carousel class="carousel-xs" indicator-position="inside" :height="isPc?'540px':calcHeight" v-show="lang == 'en'">
    <el-carousel-item v-for="(item,index) in tablelist" :key="index">
      <div class="img-div" :style="[{background: 'url('+item.picUrlEn+') no-repeat'},{backgroundSize:'cover'},{backgroundPosition:'center'}]">

      </div>
    </el-carousel-item>
  </el-carousel>
</div>
</template>

<script>
import utils from "@/utils/utils";
import mixin from "@/mixins";
export default {
  props:['isOpenParm','previewPage'],
  data() {
    return {
      tablelist: [],
      isPc:'',
    };
  },
  mixins:[mixin],
  components: {
  },
  computed:{
    calcHeight() {
      const width = window.screen.width;
      return width * 0.56 + 'px'
    }
  },
  mounted(){
    if(this.previewPage){
      this.getCarouseList();
    }else{
      if(this.isOpenParm){
        this.getCarouseList();
      }
    }
  },
  created() {
    this.isPc = utils.isPc();
  },
  methods: {
    //获取列表
    getCarouseList(){
      let data = {
        meetingCode:this.$route.params.meetingCode
      };
      this.$api.getCarouseList(data).then(res=>{
        this.tablelist = res.data.data;
      })
    },
  },
}
</script>

<style scoped lang="scss">
/* pc端样式 */
@media screen and (min-width: 900px) {
  .carousel-xs{
    margin-top:20px;
    .img-div{
      width:100%;
      height: 540px;
    }
  }
}
/* 移动端样式 */
@media screen and (max-width: 900px) {
  .carousel-xs{
    .img-div{
      width:100%;
      height: 100%;
    }
  }
}
</style>
